/* Cross-sell "Sumá a tu compra" (Ganga V2): init externo. Funciona en la ficha y en el carrito lateral, que el tema
   redibuja por AJAX (ahí los <script> inline no corren: por eso todo vive en este archivo y escucha eventos).
   Dos fuentes:
   - Ficha (data-gs-ficha): COMPLEMENTOS baratos. sections/gs-xsell.liquid trae /recommendations y la lista curada del
     carrito con las colecciones y el tipo de cada producto; acá se saltan la temporada (data-temporada, el mismo
     criterio que los parecidos de la ficha agotada), los sustitutos y los de más de $600. Van primero los de $90 a $600
     y, si quedan menos de 4, se completa con la lista curada. Si la sección falla, /recommendations con tope de $600.
   - Carrito (data-mode="cart" + data-list, lo arma snippets/gs-cart-sumar.liquid): lista a mano de handles, cada uno por
     /products/<handle>.js con caché de 10 min. Salta agotados, lo que ya está en el carrito y lo que pasa el tope de precio.
     Si faltan $700 o menos para el envío gratis, ordena por cercanía al monto: primero las que lo completan solas (de la más
     barata a la más cara) y después las demás (de la más cara a la más barata). Si no queda nada, vuelve a /recommendations
     del primer producto con tope de $600.
   Agregar: /cart/add.js con las secciones del cajón + cartUpdate del tema (lo mismo que hace el formulario de la ficha): se
   redibuja el cajón, se actualiza el contador del header y, desde la ficha, se abre el cajón. Si algo falla, vuelve al
   camino viejo (cart:refresh).
   Tachado: solo si el ahorro SUPERA el 5% del precio anterior (decisión de Emanuel 12/10/2026; ya no pide la etiqueta tachado-ok).
   Además anima la barra de envío gratis del cajón (snippets/gs-cart-envio.liquid): el relleno crece desde el valor anterior. */
(function(){
  if (window.__xsellGsLoaded) return; window.__xsellGsLoaded = true;

  var BAG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8h12l-1 12H7L6 8Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 9V7a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  function rootUrl(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function money(cents){
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    } catch(e){}
    return '$' + String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function imgUrl(src, w){ if (!src) return ''; return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  /* tachado: solo si el ahorro supera el 5%, la misma regla de snippets/gs-ahorro.liquid: el porcentaje impreso
     (redondeado para abajo) tiene que ser 6 o más ((anterior - precio) * 50 >= anterior * 3) */
  function strike(p){ var c = p.compare_at_price; return !!(c && c > p.price && (c - p.price) * 50 >= c * 3); }

  /* ---------- Modo lista (carrito) ---------- */
  var LIST_TTL = 10 * 60 * 1000;
  var LIST_KEY = 'gsCartXs:v1:';
  var listCache = {};

  /* /products/<handle>.js -> lo justo para la tarjeta (sin la descripción, que es lo que más pesa) */
  function normProduct(p){
    if (!p || !p.id) return null;
    var vars = (p.variants || []).map(function(v){
      return { id: v.id, available: !!v.available, price: v.price, compare_at_price: v.compare_at_price || null,
        options: v.options || [v.option1, v.option2, v.option3].filter(function(o){ return o != null; }) };
    });
    var best = null;
    vars.forEach(function(v){ if (v.available && (!best || v.price < best.price)) best = v; });
    var base = best || vars[0] || {};
    return { id: p.id, title: p.title || '', url: p.url || ('/products/' + p.handle), featured_image: p.featured_image || '',
      price: base.price || p.price || 0, compare_at_price: base.compare_at_price || null, available: !!(p.available && best),
      tags: p.tags || [], options: (p.options || []).map(function(o){ return { name: o.name, values: o.values || [] }; }), variants: vars };
  }

  function loadList(handles){
    var key = LIST_KEY + handles.join(',');
    var mem = listCache[key];
    if (mem && (Date.now() - mem.t) < LIST_TTL) return mem.p;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && c.t && (Date.now() - c.t) < LIST_TTL && c.items) {
        listCache[key] = { t: c.t, p: Promise.resolve(c.items) }; return listCache[key].p;
      }
    } catch(e){}
    var t = Date.now();
    var p = Promise.all(handles.map(function(h){
      return fetch(rootUrl() + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(normProduct)
        .catch(function(){ return null; });
    })).then(function(list){
      var items = list.filter(Boolean);
      if (items.length) { try { sessionStorage.setItem(key, JSON.stringify({ t: t, items: items })); } catch(e){} }
      return items;
    });
    listCache[key] = { t: t, p: p };
    p.catch(function(){ delete listCache[key]; });
    return p;
  }

  /* falta: centavos que faltan para el envío gratis; cerca: desde cuánto se ordena por cercanía */
  function rankList(list, excl, max, falta, cerca){
    var out = list.filter(function(p){ return p && p.available && !excl[String(p.id)] && p.price > 0 && p.price <= max; });
    if (falta > 0 && falta <= cerca) {
      out = out.map(function(p, i){ return { p: p, i: i }; });
      out.sort(function(a, b){
        var la = a.p.price >= falta, lb = b.p.price >= falta;
        if (la !== lb) return la ? -1 : 1;
        var d = la ? a.p.price - b.p.price : b.p.price - a.p.price;
        return d || (a.i - b.i);
      });
      out = out.map(function(x){ x.p._llega = x.p.price >= falta; return x.p; });
    } else {
      out.forEach(function(p){ p._llega = false; });
    }
    return out;
  }

  /* ---------- Ficha: complementos (sections/gs-xsell.liquid) ---------- */
  var XS_MIN = 9000, XS_MAX = 60000, XS_LLENAR = 4, XS_TOPE = 8, XS_TAMBIEN = 5;
  /* ",a,b," para buscar handles enteros con indexOf */
  function lista(txt){ return ',' + String(txt || '').toLowerCase().replace(/\s+/g, '') + ','; }
  /* Palabra principal del título ("Parlante", "Balanza", "Rodillera"): la primera que dice qué es, sin acentos ni plural */
  var VACIAS = { mini:1, set:1, kit:1, juego:1, pack:1, par:1, con:1, para:1, del:1, las:1, los:1 };
  function palabra(t){
    var s = String(t || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch(e){}
    var ws = s.match(/[a-z0-9]+/g) || [];
    for (var i = 0; i < ws.length; i++) {
      var w = ws[i];
      if (w.length > 2 && !VACIAS[w] && !/^\d+$/.test(w)) return w.length > 4 ? w.replace(/s$/, '') : w;
    }
    return '';
  }
  /* Raíz para comparar: las 5 primeras letras (tender = tendedero) o la familia si es un sinónimo (vaso = termo) */
  var FAMILIAS = { vaso:'beber', termo:'beber', botella:'beber', jarra:'beber', tazon:'beber', vasito:'beber',
    lampara:'luz', luz:'luz', foco:'luz', velador:'luz', farol:'luz', reflector:'luz',
    frazada:'abrigo', manta:'abrigo', acolchado:'abrigo', cobija:'abrigo',
    silla:'asiento', banqueta:'asiento', banco:'asiento', taburete:'asiento',
    organizador:'orden', caja:'orden', canasto:'orden', cesto:'orden', estante:'orden', repisa:'orden' };
  function raiz(w){ return w ? (FAMILIAS[w] || w.slice(0, 5)) : ''; }
  function fichaCtx(root){
    return { pid: String(root.getAttribute('data-product-id') || ''), cols: lista(root.getAttribute('data-cols')),
      tipo: String(root.getAttribute('data-type') || '').trim().toLowerCase(), precio: parseInt(root.getAttribute('data-price'), 10) || 0,
      pal: palabra(root.getAttribute('data-title')), temp: lista(root.getAttribute('data-temporada')), sueltos: lista(root.getAttribute('data-temporada-productos')) };
  }
  function enLista(cols, l){
    var c = String(cols || '').split(',');
    for (var i = 0; i < c.length; i++) { if (c[i] && l.indexOf(',' + c[i] + ',') > -1) return true; }
    return false;
  }
  function deTemporada(p, c){ return c.sueltos.indexOf(',' + p.handle + ',') > -1 || enLista(p.cols, c.temp); }
  /* Sustituto: es lo mismo (misma palabra principal), o comparte rubro/tipo con la ficha y cuesta parecido
     (el más barato vale la mitad o más). "Hogar" y "Otros" solos no cuentan: mezclan de todo. */
  function sustituto(p, c){
    if (c.pal && raiz(palabra(p.title)) === raiz(c.pal)) return true;
    var lo = Math.min(p.price, c.precio), hi = Math.max(p.price, c.precio);
    if (!(hi > 0 && lo * 2 >= hi)) return false;
    if (enLista(p.cols, c.cols)) return true;
    var t = String(p.type || '').trim().toLowerCase();
    return !!(t && t === c.tipo && t !== 'hogar' && t !== 'otros');
  }
  function elegirFicha(d, c, excl){
    var vistos = {}; vistos[c.pid] = 1;
    function sirve(p){
      if (!p || !p.available || !(p.price > 0) || p.price > XS_MAX) return false;
      if (vistos[String(p.id)] || excl[String(p.id)]) return false;
      return !deTemporada(p, c) && !sustituto(p, c);
    }
    var rango = [], baratos = [], curada = [];
    /* Los primeros recomendados sin temporada son los que muestra "También te podría gustar" (misma API, mismo orden):
       no se repiten acá */
    var tambien = 0;
    (d.recs || []).forEach(function(p){
      if (!p || deTemporada(p, c) || String(p.id) === c.pid) return;
      if (tambien < XS_TAMBIEN) { tambien++; vistos[String(p.id)] = 1; }
    });
    (d.recs || []).forEach(function(p){ if (!sirve(p)) return; vistos[String(p.id)] = 1; (p.price >= XS_MIN ? rango : baratos).push(p); });
    (d.lista || []).forEach(function(p){
      if (rango.length + curada.length >= XS_LLENAR || !sirve(p)) return;
      vistos[String(p.id)] = 1; curada.push(p);
    });
    return rango.concat(curada, baratos).slice(0, XS_TOPE);
  }

  /* ---------- Agregar ---------- */
  function sectionsToRender(){
    var s = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: s } })); } catch(e){}
    return s;
  }
  function refreshDrawer(open){ document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!open } })); }
  function openDrawer(){
    var d = document.querySelector('cart-drawer');
    if (d && !d.hasAttribute('open') && typeof d.show === 'function') d.show();
  }
  /* open: abrir el cajón al terminar (desde la ficha; en el carrito ya está abierto) */
  function addToCart(vid, open, onOk, onErr){
    var pub = window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS;
    var secs = pub ? sectionsToRender() : [];
    var body = { items: [{ id: vid, quantity: 1 }] };
    if (secs.length) { body.sections = secs.join(','); body.sections_url = window.location.pathname; }
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', credentials: 'same-origin',
      /* X-Requested-With: sin él Shopify no controla el stock en el agregado por AJAX */
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok || (j && j.status)) { var e = new Error('add'); e.data = j; throw e; } return j; }); })
      .then(function(added){
        if (!(secs.length && added && added.sections)) { refreshDrawer(open); if (onOk) onOk(); return; }
        return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            cart.sections = added.sections;
            FoxTheme.pubsub.publish(pub.cartUpdate, { cart: cart });
            if (open) openDrawer();
            if (onOk) onOk();
          })
          .catch(function(){ refreshDrawer(open); if (onOk) onOk(); });
      })
      .catch(function(e){ if (onErr) onErr(e && e.data); });
  }

  /* abre/cierra el mini-panel; con .is-qa la tarjeta crece al alto del panel (antes los talles/colores quedaban cortados) */
  function showQa(qa, on){ qa.hidden = !on; var c = qa.parentNode; if (c && c.classList) c.classList.toggle('is-qa', !!on); }

  /* onAdded(qa): qué hacer después de agregar desde el panel */
  function buildQuickAdd(p, open, onAdded){
    var variants = p.variants || [];
    var opts = p.options || [];
    if (variants.length <= 1 || !opts.length) return null;
    if (opts.length === 1 && (opts[0].name === 'Title' || (opts[0].values||[]).join('') === 'Default Title')) return null;
    var qa = document.createElement('div'); qa.className='xsell__qa'; qa.hidden = true;
    var close = document.createElement('button'); close.type='button'; close.className='xsell__qa-close'; close.innerHTML='&times;'; close.setAttribute('aria-label','Cerrar');
    close.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); showQa(qa, false); });
    qa.appendChild(close);
    var ttl = document.createElement('div'); ttl.className='xsell__qa-title'; ttl.textContent = 'Elegí y agregá'; qa.appendChild(ttl);
    var optsWrap = document.createElement('div'); optsWrap.className='xsell__qa-opts'; qa.appendChild(optsWrap);
    var addBtnQ = document.createElement('button'); addBtnQ.type='button'; addBtnQ.className='xsell__qa-add'; addBtnQ.textContent='Elegí opción'; addBtnQ.disabled=true; qa.appendChild(addBtnQ);

    var sel = new Array(opts.length).fill(null);
    function resolve(){
      if (sel.some(function(x){ return x==null; })) return null;
      for (var i=0;i<variants.length;i++){
        var vo = variants[i].options || [];
        var ok = true;
        for (var j=0;j<sel.length;j++){ if (vo[j] !== sel[j]) { ok=false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function valueAvailable(oi, val){ return variants.some(function(v){ return (v.options||[])[oi] === val && v.available; }); }
    function sync(){
      var v = resolve();
      if (v && v.available){ addBtnQ.disabled=false; addBtnQ.textContent='Agregar · '+money(v.price); }
      else if (v && !v.available){ addBtnQ.disabled=true; addBtnQ.textContent='Sin stock'; }
      else { addBtnQ.disabled=true; addBtnQ.textContent='Elegí opción'; }
    }
    opts.forEach(function(opt, oi){
      var row = document.createElement('div');
      var lab = document.createElement('span'); lab.className='xsell__qa-optlabel'; lab.textContent = opt.name; row.appendChild(lab);
      var chips = document.createElement('div'); chips.className='xsell__chips';
      (opt.values||[]).forEach(function(val){
        var c = document.createElement('button'); c.type='button'; c.className='xsell__chip'; c.textContent=val;
        if (!valueAvailable(oi, val)) c.disabled = true;
        c.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
          sel[oi]=val;
          Array.prototype.forEach.call(chips.children, function(x){ x.classList.toggle('is-sel', x===c); });
          sync();
        });
        chips.appendChild(c);
      });
      row.appendChild(chips); optsWrap.appendChild(row);
    });
    addBtnQ.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
      var v = resolve(); if (!v || !v.available) return;
      addBtnQ.disabled=true; addBtnQ.textContent='Agregando...';
      addToCart(v.id, open, function(){
        showQa(qa, false); sel.fill(null);
        Array.prototype.forEach.call(optsWrap.querySelectorAll('.xsell__chip'),function(x){x.classList.remove('is-sel');});
        sync(); if (onAdded) onAdded();
      }, function(){ addBtnQ.disabled=false; addBtnQ.textContent='Reintentá'; });
    });
    return qa;
  }

  function priceHtml(p){
    var h = '<strong>' + money(p.price) + '</strong>';
    if (strike(p)) h += ' <s>' + money(p.compare_at_price) + '</s>';
    return h;
  }

  /* Tarjeta de la ficha (la de la tanda 1: una por vista, botón redondo con la bolsa) */
  function card(p){
    var variants = p.variants || [];
    var v0 = variants[0] || {};
    var multi = variants.length > 1;
    var el = document.createElement('div'); el.className='xsell__card';
    var media = document.createElement('a'); media.className='xsell__media'; media.href=p.url;
    var img = document.createElement('img'); var isrc = imgUrl(p.featured_image, 180); if (isrc) img.src = isrc; img.alt=p.title||''; img.loading='lazy'; media.appendChild(img);
    var info = document.createElement('a'); info.className='xsell__info'; info.href=p.url;
    var nm = document.createElement('span'); nm.className='xsell__name'; nm.textContent=p.title||''; info.appendChild(nm);
    var pr = document.createElement('span'); pr.className='xsell__price'; pr.innerHTML = priceHtml(p); info.appendChild(pr);
    var add = document.createElement('button'); add.type='button'; add.className='xsell__add'; add.innerHTML=BAG;
    add.setAttribute('aria-label', multi ? 'Elegí opciones' : 'Agregar al carrito');
    function ok(){ add.classList.add('is-added'); add.innerHTML='✓'; setTimeout(function(){ add.classList.remove('is-added'); add.innerHTML=BAG; add.disabled=false; },1500); }
    var qa = buildQuickAdd(p, true, ok);
    el.appendChild(media); el.appendChild(info); el.appendChild(add); if (qa) el.appendChild(qa);
    add.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if (!qa){
        if (!v0.id || v0.available === false){ return; }
        add.disabled = true;
        addToCart(v0.id, true, ok, function(){ add.disabled=false; });
        return;
      }
      showQa(qa, true);
    });
    return el;
  }

  /* Tarjeta del carrito: chica y vertical (entran 2 y media a 390 px), con "Agregar" en texto.
     Al agregar, el tema redibuja el cajón y la tarjeta desaparece sola (ya está en el carrito). */
  function cardCart(p){
    var variants = p.variants || [];
    var v0 = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i].available) { v0 = variants[i]; break; } }
    var multi = variants.length > 1;
    var el = document.createElement('div'); el.className='xsell__card xsell__card--mini';
    var media = document.createElement('a'); media.className='xsell__media'; media.href=p.url; media.tabIndex = -1;
    var img = document.createElement('img'); var isrc = imgUrl(p.featured_image, 240); if (isrc) img.src = isrc; img.alt=p.title||''; img.loading='lazy'; img.width = 112; img.height = 112; media.appendChild(img);
    var info = document.createElement('a'); info.className='xsell__info'; info.href=p.url;
    var nm = document.createElement('span'); nm.className='xsell__name'; nm.textContent=p.title||''; info.appendChild(nm);
    var pr = document.createElement('span'); pr.className='xsell__price'; pr.innerHTML = priceHtml(p); info.appendChild(pr);
    el.appendChild(media); el.appendChild(info);
    if (p._llega) { var ll = document.createElement('span'); ll.className = 'xsell__llega'; ll.textContent = 'Con este llegás'; el.appendChild(ll); }
    var add = document.createElement('button'); add.type='button'; add.className='xsell__cta';
    add.textContent = multi ? 'Elegir' : 'Agregar';
    add.setAttribute('aria-label', (multi ? 'Elegir opciones de ' : 'Agregar al carrito: ') + (p.title || ''));
    el.appendChild(add);
    var qa = buildQuickAdd(p, false, null);
    if (qa) el.appendChild(qa);
    add.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if (qa) { showQa(qa, true); return; }
      if (!v0) return;
      add.disabled = true; add.textContent = 'Agregando...';
      addToCart(v0.id, false, null, function(err){
        var sinStock = err && (err.status === 422 || /stock|agotad|sold out/i.test(String(err.description || err.message || '')));
        add.textContent = sinStock ? 'Sin stock' : 'Reintentá';
        add.disabled = !!sinStock;
      });
    });
    return el;
  }

  function initOne(root){
    if (!root || root.dataset.xsellInit) return; root.dataset.xsellInit = '1';
    var cartMode = root.getAttribute('data-mode') === 'cart';
    var pid = root.getAttribute('data-product-id');
    var handles = (root.getAttribute('data-list') || '').split(',').map(function(h){ return h.trim(); }).filter(Boolean);
    if (!pid && !handles.length) { root.remove(); return; }
    var track = root.querySelector('[data-xsell-track]');
    var countEl = root.querySelector('[data-xsell-count]');
    var prevBtn = root.querySelector('[data-xsell-prev]');
    var nextBtn = root.querySelector('[data-xsell-next]');

    /* Métricas CACHEADAS: nunca se leen medidas dentro del handler de scroll
       (leer layout en scroll fuerza reflow sincrónico y traba/mata la pestaña en Safari iOS). */
    var M = { step:260, clientW:0, scrollW:0, pages:1, pageAmt:260 };
    function measure(n){
      var c = track.querySelector('.xsell__card');
      var w = c ? c.getBoundingClientRect().width : 0;
      M.step = (w > 20 ? w : 248) + (cartMode ? 10 : 12);
      M.clientW = track.clientWidth;
      M.scrollW = track.scrollWidth;
      var pv = (M.clientW > 10) ? Math.max(1, Math.round(M.clientW / M.step)) : 1;
      M.perView = pv;
      M.pages = Math.max(1, Math.ceil((n || 1) / pv));
      M.pageAmt = (M.clientW > 10) ? M.clientW : M.step;
      /* carrito: las flechas avanzan de a tarjetas enteras (con el ancho del cajón quedaba una cortada a la izquierda) */
      if (cartMode && M.clientW > 10) M.pageAmt = Math.max(1, Math.floor(M.clientW / M.step)) * M.step;
    }
    var ticking=false;
    /* Solo lee scrollLeft (barato); el resto sale de la caché. */
    function updateCount(){
      var sl = track.scrollLeft;
      var cur = Math.min(M.pages, Math.round(sl / (M.step * (M.perView||1))) + 1);
      countEl.textContent = cur + '/' + M.pages;
      prevBtn.disabled = sl <= 4;
      nextBtn.disabled = sl + M.clientW >= M.scrollW - 4;
    }

    var exclRaw = (root.getAttribute('data-exclude')||'').split(',').filter(Boolean);
    var excl = {}; exclRaw.forEach(function(id){ excl[String(id)] = 1; });

    function loadRecs(max){
      if (!pid) return Promise.resolve([]);
      return fetch(rootUrl() + 'recommendations/products.json?product_id='+pid+'&intent=related&limit=10')
        .then(function(r){ return r.json(); })
        .then(function(d){
          root.setAttribute('data-xsell-source', 'recs');
          var list = (d && d.products) || [];
          if (max) list = list.filter(function(p){ return p.available !== false && p.price <= max; });
          return list;
        });
    }

    var source;
    if (handles.length) {
      var max = parseInt(root.getAttribute('data-max'), 10) || 30000;
      var falta = parseInt(root.getAttribute('data-remaining'), 10) || 0;
      var cerca = parseInt(root.getAttribute('data-goal'), 10) || 70000;
      var maxRecs = parseInt(root.getAttribute('data-fallback-max'), 10) || 60000;
      source = loadList(handles)
        .then(function(list){
          var picked = rankList(list, excl, max, falta, cerca);
          if (!picked.length) throw new Error('list-empty');
          root.setAttribute('data-xsell-source', 'list');
          return picked;
        })
        .catch(function(){
          /* el título de "te faltan" promete que estas piezas te llevan al envío gratis: con el respaldo vuelve al genérico */
          var t = root.querySelector('[data-xsell-title]'); if (t) t.textContent = 'Sumá a tu compra';
          return loadRecs(maxRecs);
        });
    } else if (root.hasAttribute('data-gs-ficha')) {
      var ctx = fichaCtx(root);
      source = fetch(rootUrl() + 'recommendations/products?product_id=' + pid + '&intent=related&limit=10&section_id=gs-xsell', { credentials: 'same-origin' })
        .then(function(r){ if (!r.ok) throw new Error('xs'); return r.text(); })
        .then(function(html){
          var m = html.match(/<script[^>]*data-gs-xsell-json[^>]*>([\s\S]*?)<\/script>/);
          if (!m) throw new Error('xs');
          var d = JSON.parse(m[1]);
          root.setAttribute('data-xsell-source', 'gs');
          return elegirFicha(d, ctx, excl);
        })
        /* Sin la sección no se puede saltar la temporada ni los sustitutos: mejor no mostrar nada */
        .catch(function(){ return []; });
    } else {
      source = loadRecs(0);
    }

    source
      .then(function(products){
        products = products.filter(function(p){ return !excl[String(p.id)]; });
        if (!products.length){ root.remove(); return; }
        track.innerHTML = '';
        products.forEach(function(p){ track.appendChild(cartMode ? cardCart(p) : card(p)); });
        /* Safari re-encastra la fila al cambiar las tarjetas de carga por las de verdad: arranca siempre en la primera */
        if (cartMode) track.scrollLeft = 0;
        root.hidden = false;
        root.classList.add('is-ready');
        var n = products.length;
        measure(n); updateCount();
        /* passive: le avisa a Safari que no vamos a bloquear el scroll */
        track.addEventListener('scroll', function(){
          if(ticking) return; ticking=true;
          window.requestAnimationFrame(function(){ updateCount(); ticking=false; });
        }, {passive:true});
        prevBtn.addEventListener('click', function(){ track.scrollBy({left:-M.pageAmt, behavior:'smooth'}); });
        nextBtn.addEventListener('click', function(){ track.scrollBy({left:M.pageAmt, behavior:'smooth'}); });
        /* re-medir solo cuando cambia el layout, nunca durante el scroll */
        var rt;
        /* el cajón se redibuja en cada cambio del carrito: el bloque viejo suelta su listener en vez de acumularse */
        function onResize(){
          if (!root.isConnected) { window.removeEventListener('resize', onResize); return; }
          clearTimeout(rt);
          rt = setTimeout(function(){ measure(n); updateCount(); }, 150);
        }
        window.addEventListener('resize', onResize, {passive:true});
        if (window.ResizeObserver) { try { new ResizeObserver(function(){ measure(n); updateCount(); }).observe(track); } catch(e){} }
      })
      .catch(function(){ root.remove(); });
  }

  /* Arranque diferido: el carrusel (fetch + tarjetas) no compite con la carga de la página.
     En la ficha el bloque nace con [hidden] (sin caja), por eso no sirve IntersectionObserver.
     En el carrito: si el cajón ya está abierto (se redibujó después de agregar o cambiar cantidades) se arma YA, sin
     esperar, para que no parpadee; si está cerrado, se arma después de la carga o apenas se abre. */
  function defer(root){
    if (!root || root.dataset.xsellQueued) return; root.dataset.xsellQueued = '1';
    var done = false;
    function go(){ if (done) return; done = true; initOne(root); }
    var drawer = root.getAttribute('data-mode') === 'cart' ? root.closest('cart-drawer') : null;
    if (drawer && drawer.hasAttribute('open')) { go(); return; }
    if (drawer) drawer.addEventListener('toggle', function(){ if (drawer.hasAttribute('open')) go(); });
    if (document.readyState === 'complete') { setTimeout(go, 200); }
    else { window.addEventListener('load', function(){ setTimeout(go, 400); }, {once:true}); setTimeout(go, 4000); }
    /* si el cliente interactúa antes, lo construimos ya */
    ['touchstart','pointerdown','keydown'].forEach(function(ev){
      window.addEventListener(ev, go, {once:true, passive:true});
    });
  }

  function scan(){ document.querySelectorAll('[data-xsell]:not([data-xsell-init])').forEach(defer); }

  /* ---------- Barra de envío gratis del cajón ----------
     El Liquid ya la dibuja con el monto y el largo correctos (y crece desde 0 al abrir el cajón). Acá solo se le dice
     desde dónde crecer cuando el tema la redibuja: desde el porcentaje anterior, así se ve avanzar lo que se sumó.
     Corre en el callback del MutationObserver (microtarea, antes de pintar): el nodo nuevo nunca se ve en 0. */
  var lastPct = null;
  function envioBar(scope){
    var fills = (scope || document).querySelectorAll('.gs-envio__relleno:not([data-gs-visto])');
    for (var i = 0; i < fills.length; i++) {
      var f = fills[i];
      var pct = parseFloat(f.getAttribute('data-gs-pct')) || 0;
      f.setAttribute('data-gs-visto', '1');
      if (lastPct !== null) f.style.setProperty('--gs-desde', lastPct + '%');
      lastPct = pct;
      /* terminada la animación queda quieta: al cerrar y abrir el cajón no vuelve a crecer */
      f.addEventListener('animationend', function(ev){
        if (ev.animationName === 'gs-llenar') this.style.setProperty('--gs-desde', this.getAttribute('data-gs-pct') + '%');
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ scan(); envioBar(); });
  else { scan(); envioBar(); }

  // Re-escanear cuando el carrito se re-renderiza (drawer inyectado por AJAX)
  document.addEventListener('cart:refresh', function(){ setTimeout(scan, 60); });
  document.addEventListener('cart:updated', function(){ setTimeout(scan, 60); });
  document.addEventListener('cart:build', function(){ setTimeout(scan, 60); });

  // Respaldo: observar el drawer del carrito por si el evento no dispara
  function observeDrawer(){
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (!drawer || drawer.__xsellObs) return; drawer.__xsellObs = true;
    var pending=false;
    new MutationObserver(function(){
      envioBar(drawer);
      if(pending) return; pending=true;
      var run = function(){ if (!pending) return; pending=false; scan(); };
      window.requestAnimationFrame(run);
      setTimeout(run, 80); /* rAF no corre con la pestaña oculta */
    }).observe(drawer, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeDrawer);
  else observeDrawer();
})();
